<template>
	<div class="subscriptions">
		<div class="card rounded-0 mb-2">
			<div class="card-body">
				<div class="row">
					<div class="col-auto">
						<input type="date" class="form-control form-control-sm" placeholder="" v-model="dateFromSubscriptions" @change="getSubscriptionsLocal(1)">
					</div>
					<div class="col-auto">
						<input type="date" class="form-control form-control-sm" placeholder="" v-model="dateToSubscriptions" @change="getSubscriptionsLocal(1)">
					</div>
					<div class="col-auto">
						<input type="text" class="form-control form-control-sm" placeholder="" v-model="searchSubscription" @keyup.enter="getSubscriptionsLocal(1)">
					</div>
					<div class="col-auto">
						<button class="btn btn-primary btn-sm" @click="getSubscriptionsLocal(1)" :disabled="searchingSubscriptions">Buscar</button>
					</div>
					<div class="col-auto" v-if="getClientSystem.extras.cpil == true && false">
						<button class="btn btn-danger btn-sm" :disabled="(totalSelectedListSubscriptions == 0)" @click="showPaymentOrderModalLocal">Pagar ({{totalSelectedListSubscriptions | formatNumber}})</button>
					</div>
					<div class="col text-end">
						Mostrar: 
						<select class="form-control-sm" v-model="qRowSubscriptions" @change="setQRowLocal()">
							<option value="5">5</option>
							<option value="10">10</option>
							<option value="25">25</option>
							<option value="50">50</option>
							<option value="100">100</option>
							<option value="1000">1000</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div class="card rounded-0 text-secondary">
			<div class="card-body">
				<div>
					<div class="table-responsive">
						<table class="table table-sm table-hover">
							<thead>
								<tr>
									<th class="text-center" colspan="2">#ID</th>
									<th class="text-center" style="width:62px">Periodo</th>
									<th class="text-center">Tipo</th>
									<th class="text-center">Cargado a</th>
									<th class="text-center">Total</th>
									<th class="text-center">Fecha</th>
									<th class="text-center">Estado</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listSubscriptions" in :key="index">
									<td class="text-center" style="width:25px">
										<svg class="text-black-50 me-1 pointer" width="14" height="14" title="" v-if="item.status_id == 30 && getClientSystem.extras.cpil == true && false" @click="item.exists = !item.exists">
											<use xlink:href="#square" v-if="item.exists == 1"/>
											<use xlink:href="#check-square" v-else/>
										</svg>
									</td>
									<td class="text-center" style="width:50px">
										<router-link :to="'/subscription/' + item.token">
											{{ item.id }}
										</router-link>
									</td>
									<td class="text-center">{{ item.subscription_id }}</td>
									<td>{{ item.type_order.name }}</td>
									<td>{{ item.client_sendto.sendto }}</td>
									<td class="text-end">{{ item.total | formatNumber }}</td>
									<td class="text-center">{{ item.created_at }}</td>
									<td class="text-center">
										<span class="badge rounded-pill" :class="'text-bg-' + item.status.color">{{ item.status.name }}</span>
									</td>
								</tr>
							</tbody>
						</table>
						<div>
							<pagination :pagination="paginationSubscriptions" @getAllList="setPageSubscriptions"></pagination>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" id="paymentOrderModal">
			<div class="modal-dialog">
    			<div class="modal-content rounded-2">
			    	<div class="modal-body p-4">
						<h3 class="fw-bold mb-0">Pagar Suscripciones</h3>
						<ul class="d-grid gap-4 my-3 list-unstyled">
							<li class="d-flex gap-4 border p-3">
								<svg class="bi text-primary flex-shrink-0" width="48" height="48"><use xlink:href="#bank"/></svg>
								<div class="flex-fill">
									<h5 class="mb-0">Transferencia o Depósito:</h5>
									Los datos para transferir o hacer un depósito son los siguientes:

									<p>Nombre <span class="fw-semibold text-institutional">Corporación Iglesia Adventista del Séptimo Día</span></p>
									<span>Banco Estado</span>
									<ul>
										<li>Cuenta N° <span class="fw-semibold text-institutional">33400004345</span></li>
										<li>RUT <span class="fw-semibold text-institutional">82.745.300-5</span></li>
									</ul>
									<span>Banco BCI</span>
									<ul>
										<li>Cuenta N° <span class="fw-semibold text-institutional">32306601</span></li>
										<li>RUT <span class="fw-semibold text-institutional">82.745.300-5</span></li>
									</ul>
									<ul>
										<li>Correo <span class="fw-semibold text-institutional">pedidos@aceschile.cl</span></li>
										<li>Comentario <span class="fw-semibold text-institutional">Suscripciones {{buyOrder}}</span></li>
									</ul>
									<br>
									<span>MONTO: <span class="fw-semibold text-institutional">{{ totalSelectedListSubscriptions | formatNumber }}</span></span>
									<br>
								</div>
							</li>
							<li class="d-flex gap-4 border p-3">
								<svg class="bi text-info flex-shrink-0" width="48" height="48"><use xlink:href="#credit-card"/></svg>
								<div>
									<h5 class="mb-0">Pago en linea</h5>
									Haga click en boton Pagar, y será redirigido a Webpay Plus de Transbank
									<br>
									<span>MONTO: <span class="fw-semibold text-institutional">{{ totalSelectedListSubscriptions | formatNumber }}</span></span>
									<br></br>										
									<transbank :amount="totalSelectedListSubscriptions" :orderTokens="listSubscriptionsSelectedToken" ref="transbank" @actionAfterGetToken="actionAfterGetTokenLocal"></transbank>
									
								</div>
							</li>
						</ul>
						<div class="text-center">
							<button type="button" class="btn btn-lg btn-secondary mt-2" data-bs-dismiss="modal">Cerrar</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#paymentOrderModal" ref="btnShowPaymentOrderModal" v-show="false">
  			Abrir Modulo de Pago
		</button>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosAWN from '@/mixins/axiosAWN.js'

	import Pagination from '@/components/Pagination.vue'
	import Transbank from '@/components/TransbankComponent.vue'

	export default {
		name: 'Subscriptions',
		mixins: [mixin, axiosAWN],
		data() {
			return {
				dateFromSubscriptions: '',
				dateToSubscriptions: '',
				searchSubscription: '',
				qRowSubscriptions: 1,
				searchingSubscriptions: false,
				listSubscriptions: [],
				paginationSubscriptions: {},
				buyOrder: ''
			}
		},
		components: {
			'pagination': Pagination,
			'transbank': Transbank
		},
		computed: {
			listSubscriptionsSelectedToken() {
				let l = []
				let list = this.listSubscriptions.filter(p => p.exists == 0)
				list.forEach((e) => {
					l.push(e.token)
				})
				return l
			},
			totalSelectedListSubscriptions() {
                let total = this.listSubscriptions.reduce((a, b) => {
                                let c = (b.exists == 0) ? Math.trunc(Math.abs(b.total)) : 0 
                                return a + c
                            }, 0);
                return total.toFixed(0)
			}
		},
		methods: {
			initModuleLocal() {
				document.title = 'Suscripciones - Suscripción ACES Chile'
				this.dateFromSubscriptions = this.currentDate(-30)
				this.dateToSubscriptions = this.currentDate()
				this.qRowSubscriptions = (localStorage.getItem('qRowSubscriptions') != null) ? localStorage.getItem('qRowSubscriptions') : this.qRowDefault
				localStorage.setItem('qRowSubscriptions', this.qRowSubscriptions)
				this.getSubscriptionsLocal(1)
			},
			actionAfterGetTokenLocal(data) {
				this.buyOrder = data.buyOrder
			},
			getSubscriptionsLocal(page = 1) {
				this.searchingSubscriptions = true
				let url = this.getApiBackend + 'subscriptions'
				document.title = 'Buscando suscripciones . . .'
				let data = {
						search: this.searchSubscription,
						qRow: this.qRowSubscriptions,
						fromDate: this.dateFromSubscriptions,
						toDate: this.dateToSubscriptions,
						page: page
					}
				this.axiosAWNasyncBlock('Buscando suscripciones', 'POST', url, 'getSubscriptionsResult', data)
			},
			getSubscriptionsResult(response) {
				if(response.data.success == true) {
					this.listSubscriptions = response.data.data
					this.paginationSubscriptions = response.data.paginate
					document.title = 'Suscripciones - Suscripción ACES Chile'
				} else {
					this.getSubscriptionsResultError(response)
				}
				this.searchingSubscriptions = false
			},
			getSubscriptionsResultError(error) {
				document.title = 'Error - Suscripción ACES Chile'
				this.searchingSubscriptions = false
				this.$awn.alert('Error al querer buscar las suscripciones')
				console.log(error)
			},
			setPageSubscriptions(page) {
				this.getSubscriptionsLocal(page)
			},
			setQRowLocal() {
				localStorage.setItem('qRowSubscriptions', this.qRowSubscriptions)
				this.getSubscriptionsLocal(1)
			},
			showPaymentOrderModalLocal() {
				if(this.listSubscriptionsSelectedToken.length > 0) {
					this.buyOrder = ''
					this.$refs.btnShowPaymentOrderModal.click()
					setTimeout(() => { this.$refs.transbank.$refs.btnConnect.click() }, 500)
				}
			}
		},
		mounted () {
			this.initModule()
		}
	}
</script>
